import { Controller } from '@hotwired/stimulus'

/**
 * Insurance Confirmation Controller
 *
 * Manages the uninsured status confirmation flow in the family onboarding insurance selection step.
 * Shows a warning banner and requires explicit confirmation when "No health insurance" is selected.
 */
export default class extends Controller {
  static targets = [
    'planTypeRadio',
    'confirmationSection',
    'confirmationCheckbox',
    'checkboxContainer',
    'errorMessage',
  ]

  static values = {
    noInsuranceValue: { type: String, default: 'no_insurance' },
  }

  connect() {
    // Initialize visibility based on current selection
    this.updateVisibility()
  }

  handlePlanTypeChange() {
    this.updateVisibility()
  }

  handleCheckboxChange() {
    // Clear any error messages when checkbox is checked
    if (this.hasErrorMessageTarget && this.confirmationCheckboxTarget.checked) {
      this.errorMessageTarget.classList.add('hidden')
    }
  }

  handleContainerClick(event) {
    if (event.target === this.confirmationCheckboxTarget || event.target.tagName === 'LABEL') {
      return
    }

    this.confirmationCheckboxTarget.click()
  }

  updateVisibility() {
    const noInsuranceSelected = this.isNoInsuranceSelected()

    if (noInsuranceSelected) {
      // Show confirmation section
      this.confirmationSectionTarget.classList.remove('hidden')
    } else {
      // Hide confirmation section and reset checkbox
      this.confirmationSectionTarget.classList.add('hidden')
      if (this.hasConfirmationCheckboxTarget) {
        this.confirmationCheckboxTarget.checked = false
      }
      // Clear error message
      if (this.hasErrorMessageTarget) {
        this.errorMessageTarget.classList.add('hidden')
      }
    }
  }

  isNoInsuranceSelected() {
    const selectedRadio = this.planTypeRadioTargets.find((radio) => radio.checked)
    return selectedRadio && selectedRadio.value === this.noInsuranceValueValue
  }
}
